import { nextLine } from "components/mlpaUiComponents/LegalNote/lib";

export default {
  accessPermissionManagement: "Zugangsberechtigungsverwaltung",
  table: {
    column: {
      certificateName: "Zertifikatsnummer",
      requestedOn: "Angefordert am",
      tenantName: "Organisation",
      tenantRole: "Rolle der Organisation",
      status: "Status",
      accessRequestedTo: "Angeforderter Zugriff auf",
      typeOfRequestedData: "Art der angeforderten Daten",
      approvedBy: "Genehmigt/Abgelehnt von",
      approvedOn: "Genehmigt/Abgelehnt am",
      requestToTenant: "Angefordert bei",
      requestedBy: "Angefordert durch",
    },
  },
  gridConnectionValues: "Einheitenparameter",
  matrixParameters: "Matrixparameter",
  inertiaParameters: "Trägheitsparameter",
  openRequest: "offene Anfrage",
  buttons: {
    approveRequest: "Anfrage(n) genehmigen",
    denyRequest: "Anfrage(n) ablehnen",
  },
  modal: {
    approveTitle: "Anfrage(n) genehmigen",
    denyTitle: "Anfrage(n) ablehnen",
    approveBody: `Sind Sie sicher, dass Sie diese Zugriffsanfrage(n) genehmigen möchten?${nextLine()}Nach der Genehmigung erhalten die Benutzer des/der Mandanten Zugriff auf die Daten. Der Zugriff kann bei Bedarf jederzeit widerrufen werden.`,
    denyBody: `Sind Sie sicher, dass Sie diese Zugriffsanfrage(n) ablehnen möchten?${nextLine()}Der/die anfragende/n Benutzer/in wird/werden über Ihre Entscheidung per E-Mail informiert. Sie können bei Bedarf jederzeit einen neuen Zugriffsantrag stellen.`,
    confirmApprove: "Anfrage(n) genehmigen",
    confirmDeny: "Anfrage(n) ablehnen",
  },
  filters: {
    status: "Status",
    typeOfRequestedData: "Art der angeforderten Daten",
  },
  tabs: {
    accessRequests: "Zugriffsanfragen",
    generalAccessGrants: "Allgemeine Zugriffsfreigabe",
  },
  subTabs: {
    fileVisibility: "Benutzerdefinierte Dateisichtbarkeit",
    parameterVisibility: "Einheiten- & Matrixparameter-Sichtbarkeit",
  },
  fileVisibility: {
    title: "Benutzerdefinierte Dateisichtbarkeit",
    noData: "Keine Dateien mit benutzerdefinierter Sichtbarkeit gefunden.",
    table: {
      fileName: "Dateiname",
      certificateNumber: "Zertifikatsnummer",
      fileType: "Dateityp",
      visibleToRoles: "Sichtbar für Rollen",
      visibleToTenants: "Sichtbar für Organisationen",
      modifiedAt: "Geändert am",
    },
    buttons: {
      editVisibility: "Sichtbarkeit bearbeiten",
      revokeVisibility: "Sichtbarkeit widerrufen",
    },
    modal: {
      revokeTitle: "Dateisichtbarkeit widerrufen",
      revokeBody:
        "Sind Sie sicher, dass Sie die benutzerdefinierte Sichtbarkeit für die ausgewählte(n) Datei(en) widerrufen möchten? Die Datei(en) werden für die angegebenen Rollen/Organisationen nicht mehr sichtbar sein.",
      confirmRevoke: "Sichtbarkeit widerrufen",
      editTitle: "Dateisichtbarkeit bearbeiten",
      editBody:
        "Konfigurieren Sie die Sichtbarkeitsberechtigungen für diese Datei. Wählen Sie mindestens eine Rolle oder Organisation aus.",
      confirmEdit: "Änderungen speichern",
      roleSelection: "Zugriff für Rollen gewähren",
      tenantSelection: "Zugriff für Organisationen gewähren",
      searchTenants: "Nach Organisationen suchen...",
      searchMinCharacters: "Geben Sie mindestens 2 Zeichen ein",
      validationError: "Bitte wählen Sie mindestens eine Rolle oder Organisation aus",
    },
  },
  parameterVisibility: {
    title: "Einheiten- & Matrixparameter-Sichtbarkeitsberechtigungen",
    noData: "Keine Einheiten mit Parameter-Sichtbarkeitsberechtigungen gefunden.",
    table: {
      modelName: "Modellname",
      modelNumber: "Modellnummer",
      parameterType: "Parametertyp",
      visibleToRoles: "Sichtbar für Rollen",
      visibleToTenants: "Sichtbar für Organisationen",
      modifiedAt: "Geändert am",
    },
    buttons: {
      editVisibility: "Sichtbarkeit bearbeiten",
      revokeVisibility: "Sichtbarkeit widerrufen",
    },
    modal: {
      revokeTitle: "Parameter-Sichtbarkeit widerrufen",
      revokeBody:
        "Sind Sie sicher, dass Sie die Parameter-Sichtbarkeit für die ausgewählte(n) Einheit(en) widerrufen möchten? Die Parameter werden für die angegebenen Rollen/Organisationen nicht mehr sichtbar sein.",
      confirmRevoke: "Sichtbarkeit widerrufen",
      editTitle: "Parameter-Sichtbarkeit bearbeiten",
      editBody:
        "Konfigurieren Sie die Sichtbarkeitsberechtigungen für diesen Parameter. Wählen Sie mindestens eine Rolle oder Organisation aus.",
      confirmEdit: "Änderungen speichern",
      roleSelection: "Zugriff für Rollen gewähren",
      tenantSelection: "Zugriff für Organisationen gewähren",
      searchTenants: "Nach Organisationen suchen...",
      searchMinCharacters: "Geben Sie mindestens 2 Zeichen ein",
      validationError: "Bitte wählen Sie mindestens eine Rolle oder Organisation aus",
    },
  },
};
